import styled, { css } from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

export const ComponentTitle = styled('h2')<any>`
  font-size: ${({ isSmallScreen }): string =>
    isSmallScreen ? '20px' : '24px'};
  font-weight: 700;
  color: ${({ theme }): string => theme.DeepBlue};
  text-transform: capitalize;
  margin-right: ${({ marginRigth }): string =>
    marginRigth ? marginRigth : '1em'};
  margin-bottom: 0;

  abbr {
    text-decoration: none;
    font-size: ${modularScale(-2)};
    font-weight: 600;

    &:before {
      content: '|';
      margin: 0 ${({ theme }): string => theme.spacing.xsmall};
    }
  }
`;

export const numbersTypography = css`
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, Helvetica, Arial, sans-serif;
`;

export const primaryTypography = css`
  font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, Helvetica, Arial, sans-serif;
`;

const typography = css`
  body {
    font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI',
      Roboto, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-variant: common-ligatures contextual lining-nums;
    line-height: 1.6;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.2;
    margin-top: 0;
    margin-bottom: 0.75em;
    font-weight: 600;
  }

  h1 {
    font-size: ${modularScale(3)};

    @media only screen and (min-width: 40rem) {
      font-size: ${modularScale(6)};
    }
  }

  h2 {
    font-size: ${modularScale(2)};
  }

  h3 {
    font-size: ${modularScale(2)};
  }

  a {
    text-decoration-skip: ink;
  }
`;

export default typography;
